
import { EnergyBlockType, EnergyBlock, ENERGY_THRESHOLDS } from './types';

/**
 * Get energy zone information based on energy level
 */
export function getEnergyZone(energyLevel: number): EnergyBlock {
  let type: EnergyBlockType;
  let label: string;
  let description: string;
  let icon: string;
  let color: string;

  if (energyLevel >= ENERGY_THRESHOLDS.POWER) {
    type = 'power';
    label = 'Power';
    description = 'Peak performance zone. Best time to tackle demanding tasks.';
    icon = '⚡';
    color = '#16a34a';
  } else if (energyLevel >= ENERGY_THRESHOLDS.FOCUS) {
    type = 'focus';
    label = 'Focus';
    description = 'Good concentration. Best time for deep work.';
    icon = '🎯';
    color = '#3b82f6';
  } else if (energyLevel >= ENERGY_THRESHOLDS.DRIFT) {
    type = 'drift';
    label = 'Drift';
    description = 'Moderate energy. Suitable for routine tasks.';
    icon = '🌊';
    color = '#eab308';
  } else {
    type = 'rest';
    label = 'Rest';
    description = 'Low energy. Time for recovery and light activities.';
    icon = '😴';
    color = '#dc2626';
  }

  return {
    type,
    label,
    description,
    icon,
    color,
    percentage: energyLevel
  };
}

/**
 * Get energy type string for a given energy value (backward compatibility)
 */
export function getEnergyTypeForValue(energy: number): EnergyBlockType {
  return getEnergyZone(energy).type;
}

// Backward compatibility alias
export const getEnergyBlock = getEnergyZone;
